module.exports = __webpack_public_path__ + "static/media/cartNew.1534ec14.svg";